/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */
import '@gjensidige/builders-components/dist/style.css';

import React, { useEffect, useState } from 'react';
import { format } from 'date-fns';
import { sv } from 'date-fns/locale';
import { Flex, Link, Loader, Title } from '@gjensidige/builders-components';
import { Expandable } from '@gjensidige/builders-components';
import {
  Boat,
  Contents,
  Family,
  Vehicle
} from '@gjensidige/builders-icons/products';
import { File } from '@gjensidige/builders-icons/systems';
import { getCDNContent, resolveCDNDir } from '@gjensidige/se-content-helpers';
import { apiFetcher } from '@gjensidige/service-async';

import {
  IPIDDocument,
  PrePurchaseInfo,
  ProductDocument,
  Products,
  ProductType,
  TermsAndCondition
} from '../type/ProductDocumentType';

export function ProductDocuments() {
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [products, setProducts] = useState<Products[] | null>();
  const [productDocument, setProductDocument] = useState<
    ProductDocument[] | null
  >();

  useEffect(() => {
    getCDNContent(
      resolveCDNDir() + 'parts/configs/product-documents-map.json'
    ).then((productDomainConfigList) => {
      setProducts(productDomainConfigList);
      apiFetcher
        .getJson<ProductDocument>('/product-documents/documents/current')
        .then(function (response) {
          return response;
        })
        .then(function (jsonResponse) {
          setIsLoading(false);
          if (jsonResponse.isOk()) {
            setProductDocument(
              jsonResponse.value as unknown as ProductDocument[]
            );
          } else {
            setProductDocument(null);
          }
        });
    });
  }, []);

  const getProductIcon = (productDomain: string) => {
    switch (productDomain) {
      case '001':
        return <Vehicle />;
      case '002':
        return <Contents />;
      case '003':
        return <Family />;
      case '004':
        return <Boat />;
      default:
        return <Vehicle />;
    }
  };

  const openDocument = async (docId: number) => {
    const url =
      window.location.origin +
      '/product-documents/documents?documentId=' +
      docId;
    // Open the URL in a new tab
    window.open(url, '_blank');
  };

  const getDocumentLinks = (productCode: number) => {
    const product = productDocument?.find(
      (p) => Number(p.productCode) === productCode
    );
    if (product) {
      return (
        <>
          {product.prePurchaseInfos.map((prePurchase: PrePurchaseInfo) => (
            <>
              {!isFutureDocument(prePurchase) && (
                <div className="item" key={prePurchase.docId}>
                  <File />
                  <Link
                    className="documentLink"
                    target="_blank"
                    href="#"
                    icon={false}
                    onClick={() => openDocument(prePurchase.docId)}
                  >
                    Förköpsinformation (PDF){' '}
                    {getDateText(
                      prePurchase.startDate,
                      prePurchase.endDate,
                      prePurchase.docId
                    )}
                  </Link>
                </div>
              )}
            </>
          ))}
          {product.ipidDocuments.map((ipidDocument: IPIDDocument) => (
            <div className="item" key={ipidDocument.docId}>
              <File />
              <Link
                className="documentLink"
                target="_blank"
                onClick={() => openDocument(ipidDocument.docId)}
                icon={false}
              >
                Produktfaktablad (PDF)
              </Link>
            </div>
          ))}
          {product.termsAndConditions.map((villkor: TermsAndCondition) => (
            <>
              {!isFutureDocument(villkor) && (
                <div className="item" key={villkor.docId}>
                  <File />
                  <Link
                    className="documentLink"
                    target="_blank"
                    href="#"
                    onClick={() => openDocument(villkor.docId)}
                    icon={false}
                  >
                    Fullständiga villkor (PDF){' '}
                    {getDateText(
                      villkor.startDate,
                      villkor.endDate,
                      villkor.docId
                    )}
                  </Link>
                </div>
              )}
            </>
          ))}
        </>
      );
    }
    return null;
  };

  const isFutureDocument = (document: any): boolean => {
    if (window.location.href.includes('testgjensidige.se')) {
      return false;
    }
    const currentDate = new Date().valueOf();
    return new Date(currentDate) < new Date(document.startDate);
  };

  const getDateText = (
    startDate: string,
    endDate: string,
    docId: number
  ): string => {
    const yearStr = endDate.slice(0, 4);
    let ret = '';
    if (currentTermsDocs(startDate, endDate)) {
      ret = '';
    } else if (upcomingTermsDocs(startDate, docId)) {
      ret =
        ' - Gäller fr.o.m ' +
        format(new Date(startDate), 'd MMMM yyyy', { locale: sv });
    } else if (recentEndedTermsDocs(startDate, endDate)) {
      ret =
        ' - tecknad/förnyad före ' +
        format(new Date(endDate), 'd MMMM yyyy', { locale: sv });
    }
    return ret;
  };

  const currentTermsDocs = (startDate: string, endDate: string): boolean => {
    const currentDate = new Date().valueOf();
    return (
      new Date(currentDate) >= new Date(startDate) &&
      new Date(currentDate) <= new Date(endDate)
    );
  };

  const upcomingTermsDocs = (startDate: string, docId: number): boolean => {
    const currentDate = new Date().valueOf();
    const miunus45Days = new Date(
      new Date(startDate).valueOf() - 45 * 24 * 60 * 60 * 1000
    );
    // check if the document is upcoming within 45 days
    return (
      new Date(currentDate) >= new Date(miunus45Days) &&
      new Date(currentDate) <= new Date(startDate)
    );
  };

  const recentEndedTermsDocs = (
    startDate: string,
    endDate: string
  ): boolean => {
    const currentDate = new Date().valueOf();
    const plus365Days = new Date(
      new Date(endDate).valueOf() + 365 * 24 * 60 * 60 * 1000
    );
    // check if the document is recent ended within 45 days
    return (
      new Date(currentDate) >= new Date(endDate) &&
      new Date(currentDate) <= new Date(plus365Days)
    );
  };

  return (
    <div>
      {isLoading && (
        <div>
          <div className="documentlist-container-home">
            <Loader variant="spinner" size="lg" radius="md" />
          </div>
        </div>
      )}
      {!isLoading && (
        <>
          {products?.map((product) => (
            <Flex direction="column" center key={product.productDomain}>
              <Flex direction="row" gap="none" className="titleContainer">
                {getProductIcon(product.productDomain)}
                <Title size="body" className="title">
                  {product.productDomainName}
                </Title>
              </Flex>
              <Flex layout={{ xs: 1, md: 2 }} gap="sm xl">
                {product.productTypes.map((document: ProductType) => (
                  <div key={document.productCode}>
                    <Expandable
                      variant="white-white"
                      className="expandableItem"
                    >
                      <Expandable.Title>
                        {document.productName}
                      </Expandable.Title>
                      <Expandable.Content>
                        {getDocumentLinks(document.productCode)}
                      </Expandable.Content>
                    </Expandable>
                  </div>
                ))}
              </Flex>
            </Flex>
          ))}
        </>
      )}
    </div>
  );
}
